import { create } from "zustand";
import { querystring } from "zustand-querystring";

export type SupplierListSortType =
  | "name_asc"
  | "name_desc"
  | "last_ordered_desc"
  | "last_ordered_asc"
  | "storefront_release_date_asc";

export type SupplierListStoreState = {
  search: string;
  sort: SupplierListSortType;
  isFavourite: boolean;
};

type SupplierListStoreActions = {
  setState: (state: SupplierListStoreState) => void;
  setSearch: (search: string) => void;
  setSort: (sort: SupplierListSortType) => void;
  setIsFavourite: (isFavourite: boolean) => void;
  reset: () => void;
};

const initialSupplierListStoreState: SupplierListStoreState = {
  search: "",
  sort: "name_asc",
  isFavourite: false,
};

type SupplierListStoreType = SupplierListStoreState & SupplierListStoreActions;

export const useSupplierListStore = create<SupplierListStoreType>()(
  querystring<SupplierListStoreType>(
    (set) => ({
      ...initialSupplierListStoreState,
      setState: (newState: SupplierListStoreState) => set(newState),
      setSearch: (search: string) => set({ search }),
      setSort: (sort: SupplierListSortType) => set({ sort }),
      setIsFavourite: (isFavourite: boolean) => set({ isFavourite }),
      reset: () => set(initialSupplierListStoreState),
    }),
    {
      select(pathname) {
        const persistParam = pathname.includes("/suppliers");
        return {
          search: persistParam,
          sort: persistParam,
        };
      },
    },
  ),
);
